module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4204f979","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Masonry.vue
// module id = Tv0J
// module chunks = 1